/**
 * `sources` — the museum's own pages behind an answer. Garnish, so it is
 * compact and never competes with the plan for room.
 */

import type { SourcesCardProps } from '../generated/schemas';
import { stripEmoji as plain } from '../../lib/emoji';

export default function SourcesCard({ props }: { props: SourcesCardProps }) {
  return (
    <article className="card card--sources">
      <header className="card__head">
        <h3 className="card__title">Подробнее на сайте музея</h3>
      </header>
      <ul className="links">
        {props.items.map((item) => (
          <li key={item.url}>
            <a href={item.url} target="_blank" rel="noreferrer noopener">
              {plain(item.title)}
            </a>
          </li>
        ))}
      </ul>
    </article>
  );
}
